module.exports = __webpack_public_path__ + "img/plusfl_2.49f67ab7.png";